import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { ManagementApiService } from '../../../../../services';
import { SharedContentCategory } from '../../../enums/shared-content-category.enum';
import { SharedContentModel } from '../../../models/general/shared-content-model';
import { SettingValueModel } from '../../../models/informate';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-shared-content-list',
    templateUrl: './shared-content-list.component.html',
    styleUrls: ['./shared-content-list.component.scss'],
})
export class SharedContentListComponent implements OnInit, OnChanges {
    @Input() generalTabIndex: number;
    @Input() language: SettingValueModel;
    @Input() sharedContentType: string;

    tooltip_position = 'above';
    sharedContentsList: SharedContentModel[] = null;
    hideDeleteOption: boolean;
    hideEditOption: boolean;
    sharedContentsListCopy: SharedContentModel[];
    method: string;
    currentTabIndex: number;
    currentLanguage: SettingValueModel;
    stateOptions: any[];

    constructor(
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private transLocoService: TranslocoService
    ) {
        this.stateOptions = [
            { label: this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.FREE'), value: 'Free' },
            { label: this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.PURCHASE'), value: 'Purchase' },
        ];
    }

    async ngOnInit(): Promise<void> {
        this.currentTabIndex = this.generalTabIndex;
        this.currentLanguage = this.language;
        this.globalEmittersService.refreshContentGeneralSetting.subscribe(async (value) => {
            if (value) {
                await this.getSharedContents();
            }
        });
    }

    async ngOnChanges(): Promise<void> {
        if (
            (this.currentTabIndex != this.generalTabIndex || this.language != this.currentLanguage) &&
            this.generalTabIndex !== undefined &&
            this.generalTabIndex !== null &&
            this.language
        ) {
            await this.getSharedContents();
            this.currentTabIndex = this.generalTabIndex;
            this.currentLanguage = this.language;
        }
    }

    async refreshDataHandler(generalTabIndex: number) {
        await this.getSharedContents();
    }

    async getSharedContents() {
        if (this.generalTabIndex !== undefined && this.generalTabIndex !== null && this.language) {
            this.sharedContentsList = [];
            this.ngxUiLoaderService.start();
            this.mgmtApi.getSharedContents(await this.getSharedContentCategory(), this.language?.settingValueId, null).subscribe(
                (sharedContents) => {
                    this.ngxUiLoaderService.stop();
                    this.sharedContentsListCopy = [];
                    if (sharedContents.success == true) {
                        this.sharedContentsList = sharedContents.response;
                        this.sharedContentsList.forEach((x) => {
                            let obj: any = {};
                            obj.sharedContentId = x.sharedContentId;
                            obj.sharedContentCategory = x.sharedContentCategory;
                            obj.sharedContentCategoryId = x.sharedContentCategory.sharedContentCategoryId;
                            obj.heading = x.heading;
                            obj.subHeading = x.subHeading;
                            obj.isPurchase = x.isPurchase;
                            x.isPurchase == true ? (obj.method = 'Purchase') : (obj.method = 'Free');
                            obj.navigationLink = x.navigationLink;
                            obj.navigationText = x.navigationText;
                            obj.imageLocation = x.imageLocation;
                            obj.price = x.price;
                            obj.language = x.language;
                            obj.image = x.image;
                            obj.sharedContentType = x.sharedContentType;
                            obj.date = x.date;

                            this.sharedContentsListCopy.push(obj);
                        });
                        this.cd.markForCheck();
                    } else {
                        this.user_utility.errorModelPopup(sharedContents.message);
                    }
                },
                (error) => {
                    this.ngxUiLoaderService.stop();
                }
            );
        }
    }

    async getSharedContentCategory(): Promise<SharedContentCategory> {
        switch (this.generalTabIndex) {
            case 0:
                await this.checkUserPermissions('heroImages');
                return SharedContentCategory.HeroImages;
            case 1:
                await this.checkUserPermissions('news');
                return SharedContentCategory.NewsUpdates;
            case 2:
                await this.checkUserPermissions('Pricing');
                return SharedContentCategory.Pricing;
            case 3:
                return SharedContentCategory.SocialMedia;
        }
    }

    async checkUserPermissions(permission: string) {
        this.hideDeleteOption = await this.user_utility.checkUserPermissionDataAndRoute(permission, userActions.Delete);
        this.hideEditOption = await this.user_utility.checkUserPermissionDataAndRoute(permission, userActions.Edit);
    }
}
